/**
 * Formatter Utilities
 *
 * Common formatting functions for dates, numbers, currency, etc.
 */

/**
 * Format a date to a readable string
 */
export const formatPriority = (priority: number) => {
  const priorities: Record<number, string> = {
    1: 'Baja',
    2: 'Media',
    3: 'Alta'
  };

  return priorities[priority] || 'Sin prioridad';
};

export const formatState = (priority: number) => {
  const priorities: Record<number, string> = {
    1: 'Pendiente',
    2: 'Logistica',
    3: 'Espera de Repuesto', 
    4: 'Remitido',
    5: 'En Destino',
    6: 'Asignado',
    7: 'En Curso',
    8: 'Cerrado'
  };

  return priorities[priority] || 'Sin estado';
};

export const formatStateE = (priority: number) => {
  const priorities: Record<number, string> = {
    1: 'Operativo',
    2: 'Fallando',
    3: 'Baja'
  };

  return priorities[priority] || 'Sin estado';
};
export const formatStateR= (priority: number) => {
  const priorities: Record<number, string> = {
    1: 'Pendiente',
    2: 'Cargado'
  };

  return priorities[priority] || 'Sin estado';
};
export const Categories = (category: number) => {
  const priorities: Record<number, string> = {
    1: 'Stock',
    2: 'CEL',
    3: 'Taller',
    4: 'Prestador',
    5: 'CEL (PARTICULARES)',
    6: 'CRI',
    7: 'CGP',
    8: 'CEL IDX'
  };

  return priorities[category] || 'Sin categoría';
};

export const formatGroup = (group: number) => {
  const groups: Record<number, string> = {
    1: 'Cambio de equipo',
    2: 'Configuracion',
    3: 'Consumibles laboratorio',
    4: 'Electrico',
    5: 'Impresion',
    6: 'Instalacion',
    7: 'Laminador',
    8: 'Mantenimiento-Limpieza',
    9: 'Recorrido',
    10: 'Eléctrico',
    11: 'Insumos',
    12: 'Re-Capacitación',
    13: 'Reemplazo de Parte',
    14: 'Remota'
  };

  return groups[group] || 'Sin grupo';
};
